import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "reason",
    "medicalItems"
  ]

  onReasonChanged() {
    if (this.reasonTarget.value == "no_medical_record" || this.reasonTarget.value == "incomplete_medical_record") {
      this.medicalItemsTarget.classList.remove("hidden");
    } else {
      this.medicalItemsTarget.classList.add("hidden");
    }
  }
}